const styles = theme => ({
  modal: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    minWidth: '740px',
    position: 'relative',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      top: '0',
      left: '0',
      transform: 'translate(0)',
      minWidth: '100%',
      borderRadius: '0',
      height: '100%',
    },
  },
  modalTitleHead: {
    padding: '12px 6px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '& h1': {
      color: theme.palette.primary.adgmBlack,
      padding: '0px 12px',
      [theme.breakpoints.down('sm')]: {
        padding: '0px 0px',
        fontSize: '16px',
        fontWeight: 500,
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      paddingTop: '20px',
      borderBottom: '3px solid #EBEEF3',
      '& img': {
        display: 'inline-block',
      },
    },
  },
  backIconBtn: {
    display: 'none',
    transform: `${theme.direction === 'rtl' && 'rotate(180deg)'}`,
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  crossIconBtn: {
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  rightAction: {
    marginLeft: 'auto',
  },
  modalPaper: {
    position: 'absolute',
    width: '50%',
    backgroundColor: '#fff',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      borderRadius: '0px',
    },
  },
  requiredStar: {
    color: theme.palette.primary.main + '!important',
  },
  modalBody: {
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0px',
    },
  },
});

export default styles;
